import React from "react";

// ✅ services array define karo
const services = [
  {
    title: "Search Your Frame",
    desc: "There are many variations lorem Ipsum available majority.",
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2" fill="none" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" stroke="currentColor" strokeWidth="2" />
      </svg>
    ),
  },
  {
    title: "Customize Your Lens",
    desc: "There are many variations lorem Ipsum available majority.",
    icon: (
      <svg viewBox="0 0 24 24">
        <rect x="3" y="3" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="2" fill="none" />
      </svg>
    ),
  },
  {
    title: "Quickly Checkout",
    desc: "There are many variations lorem Ipsum available majority.",
    icon: (
      <svg viewBox="0 0 24 24">
        <path d="M3 3h18v4H3zM5 7l2 14h10l2-14" stroke="currentColor" strokeWidth="2" fill="none" />
      </svg>
    ),
  },
  {
    title: "Receive Your Glasses",
    desc: "There are many variations lorem Ipsum available majority.",
    icon: (
      <svg viewBox="0 0 24 24">
        <circle cx="7" cy="17" r="2" />
        <circle cx="17" cy="17" r="2" />
        <path d="M5 17h14l-1-10H6z" stroke="currentColor" strokeWidth="2" fill="none" />
      </svg>
    ),
  },
];

const NewCurations = () => {
  return (
    <>
      {/* Header */}
      

      {/* Services */}
      <section className="service-section">
        <div className="container">
          <div className="service-grid">
            {services.map((item, index) => (
              <div className="service-card" key={index}>
                <div className="icon-wrap">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default NewCurations;
